import type { UseHttp } from '~~/server/api/interface'

export const fetchExhibitionList: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibition/list', params, { ...option })
}

export const fetchExhibitionRelatedList: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibition/relatedList', params, { ...option })
}

export const fetchExhibitionPage: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibition/page', params, { ...option })
}

export const fetchExhibitionFollow: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibition-follow/follow', params, { ...option })
}

export const fetchExhibitionById: UseHttp = (params, option) => {
  return useHttp.get(`/api/exhibition/${params?.id}`, undefined, { ...option })
}

export const fetchExhibitionGroup: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibitionGroupApi/group', params, { ...option })
}

export const fetchExhibitionBoothInfoById: UseHttp = (params, option) => {
  return useHttp.get(`/api/exhibition/boothInfo/${params?.id}`, undefined, { ...option })
}

export const fetchExhibitionScoreById: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibitionScoreApi/getByEhibitionId', params, { ...option })
}

export const fetchVideoPlayAuth: UseHttp = (params, option) => {
  return useHttp.get(`/api/exhibition/getPlayAuth/${params?.vid}`, undefined, { ...option })
}

export const fetchApplyBooth: UseHttp = (params, option) => {
  return useHttp.post(`/api/exhibition/applyBooth`, params, { ...option })
}

export const fetchExhibitionDimension: UseHttp = (params, option) => {
  return useHttp.post(`/api/exhibition/dimension`, params, {
    ...option
  })
}
// 查询地区是否有展会
export const clientFetchExhibitionDimension: UseHttp = (params, option) => {
  return useHttp.post(`/api/exhibition/dimension`, params, {
    ...option
  })
}

export const fetchCityByType: UseHttp = (params, option) => {
  return useHttp.get(`/api/exhibition/city/${params?.type}`, undefined, { ...option })
}

export const clientFetchQueryListByKeyWord: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibition/queryListByKeyWord', params, { ...option })
}

export const clientFetchExhibitionSearch: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibition/search', params, { ...option })
}

export const fetchExhibitionSearch: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibition/search', params, { ...option })
}

export const fetchClientExhibitionSearch: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibition/search', params, { ...option })
}

// 获取别名
export const fetchExhibitionAliasList: UseHttp = (params, option) => {
  return useHttp.post('/api/wiki/aliasList', params, { ...option })
}
export const fetchHotelList: UseHttp = (params, option) => {
  return useHttp.post('/api/aliTripApi/hotelList', params, { ...option })
}
export const fetchExhibitionPavilionList: UseHttp = (params, option) => {
  return useHttp.get('/api/exhibitionPavilion/list', params, { ...option })
}
export const fetchExhibitionResource: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibitionResource/get', params, { ...option })
}
export const fetchExhibitionFollowedUsers: UseHttp = (params, option) => {
  return useHttp.post('/api/followeApi/getExhibitionFollowedUsers', params, { ...option })
}

export const fetchCheckFollowUserInfo: UseHttp = (params, option) => {
  return useHttp.post('/api/followeApi/checkFollowUserInfo', params, { ...option })
}

export const fetchUpdateFollowUserInfo: UseHttp = (params, option) => {
  return useHttp.post('/api/followeApi/updateFollowUserInfo', params, { ...option })
}
// exhibition
export const fetchOrderStatus: UseHttp = (params, option) => {
  return useHttp.get(`/api/pay/queryOrderStatus/${params?.id}/1`, undefined, { ...option })
}

export const fetchSaveVisitors: UseHttp = (params, option) => {
  return useHttp.post('/api/pay/saveVisitors', params, { ...option })
}

/**
 * 重新付款
 * @param params
 * @param option
 */
export const fetchRePayment: UseHttp = (params, option) => {
  return useHttp.post('/api/ticketOrderApi/rePayment', params, { ...option })
}

export const fetchOrderStatusByOrderNo: UseHttp = (params, option) => {
  return useHttp.get(`/api/pay/queryOrderStatusByOrderNo/${params?.orderNo}`, params, { ...option })
}

export const fetchCreatePreOrder: UseHttp = (params, option) => {
  return useHttp.post('/api/pay/createPreOrder', params, { ...option })
}

export const fetchTicketById: UseHttp = (params, option) => {
  return useHttp.get(`/api/ticket/query/${params?.id}`, undefined, { ...option })
}
